<adapt-feature-guidance [configItem]="configItem">
    <p>Lumia Assistant is an AI-powered tool designed to provide insights, answer questions, and assist with various tasks related to your
        organisation's use of the Lumia platform. It can help you navigate the platform more effectively and make informed decisions based
        on your organisational data.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem">
</adapt-feature-configuration>
